import { orchestrator } from 'satcheljs';
import { patchOutlookSpace } from '../service';
import { resetProjectUnseenCapturedCount, timeStreamProjectUpdated } from '../actions';

orchestrator(resetProjectUnseenCapturedCount, async ({ id }) => {
    // when we show the capture pane, clear the unseen item count
    try {
        const updatedCapturedCount = { unseenCapturedCount: 0 };
        await patchOutlookSpace(id, updatedCapturedCount);
        timeStreamProjectUpdated(id, updatedCapturedCount, true);
    } catch {
        // if the update fails, no loss of functionality. Ignore, will try again next time user toggles, less intrusive than asking for retrying
    }
});
